import { createSelector } from "reselect";
import { RootState } from "../reducers";
import { mapCaseAndDistributionListToCaseFollows } from "./utils";

export const selectCaseFollows = (state: RootState) =>
  state.caseFollows.caseFollows;

export const selectCaseFollowsIncluded = (state: RootState) =>
  state.caseFollows.included;

export const selectCaseFollowUsers = createSelector(
  selectCaseFollowsIncluded,
  included => included.filter(related => related.type === "users"),
);

export const selectMappedCases = createSelector(
  selectCaseFollows,
  selectCaseFollowsIncluded,
  mapCaseAndDistributionListToCaseFollows,
);
